import React, { useContext } from 'react';
import "../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../layouts/Layouts.css";
import Button from '../../lib/ui/buttons/Button';
import { LangCtx } from "../../lib/context";
import { useHistory } from 'react-router-dom';

const ConfirmMsgPopup = (props) => {
    const { l } = useContext(LangCtx);
    const history = useHistory();

    const handleOk = () => {
        history.push("/");
    }

    return (
        <div className="coverContainer">
            <div className="outSideContainer">
                <div className="overlayCentreMsg">
                    <div className="centreMsgHdng">
                        <img src="/images/icons/success.png" alt="icon" />
                        <h2>{l.paymnt_compt}</h2>
                    </div>
                    <p>{l.paymnt_conf_msg}</p>
                    <div className="mrgTop16">
                        <Button label={l.okay}
                            type='outLine'
                            size='md'
                            onClick={handleOk}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ConfirmMsgPopup;